@if (links?.length) {
  <div class="impacting-warning">
    <div class="impacting-warning-label" [ngClass]="{ reduce: isClose }">
      <mat-icon class="red" svgIcon="important"></mat-icon>
      <span>{{ message | translate }}</span>
      <mat-icon class="toggle-icon" [svgIcon]="isClose ? 'plus' : 'minus'" (click)="toggle()"></mat-icon>
    </div>
    <ul class="impacting-warning-content" [ngClass]="{ 'hide-not-in-print': isClose }">
      @for (link of links; track link.id) {
        <li>
          <!-- Display the document type only when viewing linked datamodules. -->
          @if (link.type) {
            <span>{{ "linked.type." + link.type | translate }} - </span>
          }
          <span class="span_links" (click)="navigateTo(link.id)"> {{ link.label }} </span>
        </li>
      }
    </ul>
  </div>
}
